import React from 'react';
import { getEffectivePrice, formatPrice } from '@3dera/core/utils/pricing';
import styles from './PriceTag.module.css';

const PriceTag = ({ product, className = '' }) => {
  const { base, price, isDiscounted, percent } = getEffectivePrice(product);
  if (!isDiscounted) {
    return <span className={`${styles.price} ${className}`}>{formatPrice(price)}</span>;
  }
  return (
    <span className={`${styles.wrap} ${className}`}>
      <span className={styles.badge}>%{percent}</span>
      <span className={styles.old}>{formatPrice(base)}</span>
      <span className={styles.now}>{formatPrice(price)}</span>
    </span>
  );
};

export default PriceTag;
